export class QualidadeCafeFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getQualidades(filter) {
    return this.instance.get('/v1/cat-qualidades', {
      params: filter,
    });
  }

  addQualidade(data) {
    return this.instance.post('/v1/cat-qualidades', data);
  }

  editQualidade(id, data) {
    return this.instance.put(`/v1/cat-qualidades/${id}`, data);
  }

  deleteQualidade(id) {
    return this.instance.delete(`/v1/cat-qualidades/${id}`);
  }
}

export default (...params) => new QualidadeCafeFactory(...params);
